import { useTranslate } from "hooks";
import React from "react";
import * as Scrivito from "scrivito";

export const ProjectListTitle = Scrivito.connect(() => {
  const translate = useTranslate();
  return (
    <h3 className="text-uppercase mb-0" data-testid="MY_PROJECTS">
      {translate("MY_PROJECTS")}
    </h3>
  );
});
